module.exports = __webpack_public_path__ + "img/1.d5ff5285.jpg";